import styled from '@emotion/styled';
import {
  ListItemButton,
  ListItemButtonProps
} from '@portalterreno/react-ui-core/List';

export type StyledListItemProps = ListItemButtonProps & {
  as?: string;
};

const StyledListItem = styled(ListItemButton)<StyledListItemProps>({
  paddingRight: 0,
  paddingLeft: 0,
  width: '100%'
});

export default StyledListItem;
